<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="toc" id="toc">
<h1 class="ctfm"><a class="page" id="pvii"></a>Contents</h1>
<p class="tocfm"><a class="xref" href="#/chirapp0009#pref">Preface: “Baseball’s Sad Lexicon”</a></p>
<p class="toc"><a class="xref" href="#/chirapp0011#ch01"><b>1</b>  Baseball’s Golden Era and Dark Age</a></p>
<p class="tocpt"><a class="xref" href="#/chirapp0012#pt01"><span class="sm-b">PART</span> <span class="sm-b">ONE</span>  <span class="sm">BOYS</span> <span class="sm">TO</span> <span class="sm">MEN</span></a></p>
<p class="toc"><a class="xref" href="#/chirapp0014#ch02"><b>2</b>  The Irish Game: <i>Johnny Evers in Troy</i></a></p>
<p class="toc"><a class="xref" href="#/chirapp0016#ch03"><b>3</b>  The Midwestern Game: <i>Joe Tinker in Kansas City</i></a></p>
<p class="toc"><a class="xref" href="#/chirapp0018#ch04"><b>4</b>  The Western Game: <i>Frank Chance in Fresno</i></a></p>
<p class="tocpt"><a class="xref" href="#/chirapp0019#pt02"><span class="sm-b">PART</span> <span class="sm-b">TWO</span>  <span class="sm">CHICAGO</span> <span class="sm">CENTURY</span></a></p>
<p class="toc"><a class="xref" href="#/chirapp0020#ch05"><b>5</b>  Baseball Revival, 1903–1905</a></p>
<p class="toc"><a class="xref" href="#/chirapp0021#ch06"><b>6</b>  Baseball Insanity, 1906</a></p>
<p class="tocpt"><a class="xref" href="#/chirapp0022#pt03"><span class="sm-b">PART</span> <span class="sm-b">THREE</span>  <span class="sm">DYNASTIC</span> <span class="sm">CYCLES</span></a></p>
<p class="toc"><a class="xref" href="#/chirapp0023#ch07"><b>7</b>  Conquest into Culture, 1907</a></p>
<p class="toc"><a class="xref" href="#/chirapp0024#ch08"><b>8</b>  Team of Destiny, 1908</a></p>
<p class="toc"><a class="xref" href="#/chirapp0026#ch09"><b>9</b>  Destiny Dissolves, 1909–1912</a></p>
<p class="toc"><a class="xref" href="#/chirapp0027#epil">Epilogue: Hall of Fame</a></p>
<p class="tocbmf"><a class="xref" href="#/chirapp0028#acknow">Acknowledgments</a></p>
<p class="tocbm"><a class="xref" href="#/chirapp0029#app">Appendix: Diaspora</a></p>
<p class="tocbm"><a class="xref" href="#/chirapp0030#abbrev">Abbreviations Used in Notes</a></p>
<p class="tocbm"><a class="xref" href="#/chirapp0031#notes">Notes</a></p>
<p class="tocbm"><a class="xref" href="#/chirapp0032#index">Index</a></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-rapp-0008.vue?460feb32